





import { defineComponent, PropType, computed } from '@nuxtjs/composition-api';
import { HomeComponent, HomeComponentContent, HomeComponentType, productsCollection } from '~/features/home';
const componentMapper: Record<HomeComponentType, string> = {
  [HomeComponentType.PRODUCTS_CAROUSEL]: 'HomeProductCarouselFragment',
  [HomeComponentType.RECENTLY_VIEWED_CAROUSEL]: 'HomeNonCachedProductsFragment',
  [HomeComponentType.BEST_SELLERS_CAROUSEL]: 'HomeNonCachedProductsFragment',
  [HomeComponentType.OFFERS]: 'HomeOfferComponentFactory',
  [HomeComponentType.FEATURED_CATEGORIES]: 'HomeCategoryFragment',
  [HomeComponentType.ABOUT_BLOCKS]: 'HomeInformativeBannerFragment',
  [HomeComponentType.PRODUCT_COLLECTION]: 'HomeCollectionProductSlider',
};

export default defineComponent({
  props: {
    items: {
      type: Array as PropType<HomeComponent<HomeComponentContent>[]>,
      default: () => [],
    },
  },
  setup(props) {
    const mapItem = (item: HomeComponent<HomeComponentContent>) => ({
      ...item,
      component: componentMapper[item.type],
    });

    const homeItems = computed(() => {
      const collectionItems = productsCollection(props.items);
      const mappedItems = Array.from(
        new Set(
          props.items.map(item => {
            const collection = collectionItems.find(col => col.componentStyle === item.componentStyle);
            return collection || item;
          })
        )
      );
      return mappedItems?.map(mapItem);
    });

    return {
      homeItems,
    };
  },
});
